var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGroceries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.895 6.158c0-.784.636-1.42 1.42-1.42h11.369a1.421 1.421 0 010 2.841H3.316a1.421 1.421 0 01-1.421-1.42z",
    fill: "#41CBCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.869 2.18L4.737 5.874M11.369 2.18L13.5 5.874",
    stroke: "#41CBCE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.982 9.65a1 1 0 01.993-1.124h10.05a1 1 0 01.992 1.124l-.478 3.827a3 3 0 01-2.977 2.628H6.438a3 3 0 01-2.977-2.628L2.982 9.65zm7.913.771c.523 0 .947.424.947.947v1.895a.947.947 0 01-1.895 0v-1.895c0-.523.424-.947.948-.947zm-2.842.947a.947.947 0 00-1.895 0v1.895a.947.947 0 001.894 0v-1.895z",
    fill: "#41CBCE"
  })));
}

export default SvgGroceries;